export const page = ({ theme: { colors }, margin }) => ({
    borderRadius: '6px',
    backgroundColor: colors.white,
    margin,
});
